export const FILE_UPLOAD_LIMIT_MB = 10;
